import { ActivityIndicator, StyleSheet, View } from 'react-native';

export interface LoadingSpinnerProps {
  size?: 'small' | 'large';
  color: string;
  backgroundColor: string;
}

export const LoadingSpinner = ({ size = 'large', color, backgroundColor }: LoadingSpinnerProps) => {
  return (
    <View style={[styles.container, { backgroundColor }]}>
      <ActivityIndicator size={size} color={color} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
